import { lastDays } from '@/lib/dates';
import type { ViewRange } from '@/lib/view-range';

/** The first view of a measurement, which entering the page prefetches. */
export const DEFAULT_BODY_RANGE: ViewRange = '1y';

// Whole days up to the end of today. The longest stays inside the 366 days
// one measurements read may cover.
const DAYS: Record<ViewRange, number> = { '1m': 31, '3m': 92, '1y': 365 };

/** A range as the measurements read takes it: instants, the end exclusive. */
export function bodyRange(range: ViewRange, today: string) {
  return lastDays(today, DAYS[range]);
}
